import { render } from "./EditorPageThumb.vue?vue&type=template&id=75e61a2f"
import script from "./EditorPageThumb.vue?vue&type=script&lang=js"
export * from "./EditorPageThumb.vue?vue&type=script&lang=js"

import "./EditorPageThumb.vue?vue&type=style&index=0&id=75e61a2f&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__